import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonStyled,
  DropDownStyled,
} from '@nike/nike-design-system-components';
import { Heading, HeadingLevel } from '@nike/web-a11y-ariakit-react';
import { MEASUREMENTS_UNITS } from '@nike/ciclp-config';
import {
  BRA_SIZE_CALCULATION_TABLE,
  BRA_SIZE_CALCULATION_TABLE_ASIA,
  isAsiaBraSizeCountry,
} from '@nike/ciclp-config/braSizeFinder';
import styles from './styles.styl';
import { formatDropdownOptionValue } from './helpers';

export const CupInputSlide = ({
  underbustValue,
  cupValue,
  selectedUnits,
  translations,
  onNextClick,
  onSelect,
  title,
  copy,
  countryCode,
}) => {
  const braSizeCalculationTable = isAsiaBraSizeCountry(countryCode)
    ? BRA_SIZE_CALCULATION_TABLE_ASIA
    : BRA_SIZE_CALCULATION_TABLE;
  const possibleCups = braSizeCalculationTable.find(
    ({ underbust }) => underbust[selectedUnits] === underbustValue,
  )?.cups;
  const dropdownOptions =
    possibleCups?.map(cupSize => {
      return {
        label: formatDropdownOptionValue(
          cupSize[selectedUnits],
          selectedUnits,
          translations,
        ),
        value: cupSize[selectedUnits],
      };
    }) || [];

  const handleSelect = event => {
    const selectedCup = possibleCups.find(cup => {
      return cup[selectedUnits] === event.target.value;
    });
    onSelect(selectedCup);
  };

  return (
    <div className={styles.content} data-testid="content">
      <HeadingLevel level={3}>
        <Heading
          className={styles.contentHeading}
          data-testid="content-heading"
        >
          {title}
        </Heading>
      </HeadingLevel>
      <p className={styles.contentCopy} data-testid="content-copy">
        {copy}
      </p>
      <div className={styles.inputWrapper} data-testid="input-wrapper">
        <DropDownStyled
          name="cup"
          id="cup"
          placeholder={translations.bra_size_finder_select_placeholder}
          options={dropdownOptions}
          label={translations.bra_size_finder_select_placeholder}
          value={cupValue?.[selectedUnits]}
          onChange={handleSelect}
        />
      </div>
      <div>
        <ButtonStyled
          onClick={onNextClick}
          data-qa="next-button"
          disabled={!cupValue}
          size="responsive"
        >
          {translations.next}
        </ButtonStyled>
      </div>
    </div>
  );
};

CupInputSlide.propTypes = {
  copy: PropTypes.string,
  countryCode: PropTypes.string,
  cupValue: PropTypes.shape({
    [MEASUREMENTS_UNITS.IMPERIAL]: PropTypes.string,
    [MEASUREMENTS_UNITS.METRIC]: PropTypes.string,
    results: {
      alpha: PropTypes.string,
      hybrid: PropTypes.string,
    },
  }),
  onNextClick: PropTypes.func,
  onSelect: PropTypes.func,
  selectedUnits: PropTypes.string,
  title: PropTypes.string,
  translations: PropTypes.shape({
    bra_size_finder_select_placeholder: PropTypes.string,
    next: PropTypes.string,
  }),
  underbustValue: PropTypes.string,
};
